import { createContext, useContext, useState, ReactNode } from 'react';

interface LocalModalContextType {
  isLocalModalOpen: boolean;
  setLocalModalOpen: (open: boolean) => void;
}

const LocalModalContext = createContext<LocalModalContextType | undefined>(undefined);

export const LocalModalProvider = ({ children }: { children: ReactNode }) => {
  const [isLocalModalOpen, setIsLocalModalOpen] = useState(false);

  const setLocalModalOpen = (open: boolean) => {
    setIsLocalModalOpen(open);
  };

  return (
    <LocalModalContext.Provider value={{ isLocalModalOpen, setLocalModalOpen }}>
      {children}
    </LocalModalContext.Provider>
  );
};

export const useLocalModal = () => {
  const context = useContext(LocalModalContext);
  if (context === undefined) {
    throw new Error('useLocalModal must be used within a LocalModalProvider');
  }
  return context;
};